import { readFrameData } from "../../../lib/frame-data";
import { isAllowedWidgetUrl } from "../../../lib/widget-iframe-security";

/** The signed buy page URL the server put in the page, or null. */
export function pageWidgetUrl(): string | null {
  const url = readFrameData().widget?.url;
  return typeof url === "string" && isAllowedWidgetUrl(url) ? url : null;
}
